<template>
  <v-container id="user-tables" fluid tag="section">
    <base-material-card icon="mdi-clipboard-text" class="px-5 py-3">
      <v-card-title>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#1b5e20"
              class="white--text"
              elevation="2"
              v-bind="attrs"
              v-on="on"
              v-if="user.roles == 'ADMIN'"
              >Add User</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Name"
                        required
                        :rules="nameRules"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedItem.username"
                        label="Username"
                        required
                        :rules="usernameRules"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12" v-if="user.roles == 'ADMIN'">
                      <v-select
                        v-model="editedItem.roles"
                        :items="items"
                        label="Select Role"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-label>Cover Avatar</v-label>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <img
                        :src="getImage('/' + editedItem.avatar)"
                        height="100px"
                        width="100px"
                        contain
                      />
                      <v-file-input
                        truncate-length="15"
                        @change="onFileSelected"
                        ref="fileImage"
                        required
                        :rules="imageRules"
                      >
                      </v-file-input>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedItem.phone"
                        label="Phone"
                        required
                        :rules="phoneRules"
                        append-icon="mdi-phone"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedItem.email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                        append-icon="mdi-email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedItem.password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="passwordRules"
                        :type="showPassword ? 'text' : 'password'"
                        label="Password"
                        hint="At least 6 characters"
                        counter
                        @click:append="showPassword = !showPassword"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#1b5e20" class="white--text" elevation="2" @click="close">
                Cancel
              </v-btn>
              <v-btn color="#1b5e20" class="white--text" elevation="2" @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <div class="warning text-center">
              <header class="text-h5">Confirmation</header>
            </div>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this {{ editedItem.name }} ?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#1b5e20"
                class="white--text"
                elevation="2"
                @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn
                color="#1b5e20"
                class="white--text"
                elevation="2"
                @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="keyword"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @input="doSearch"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        ref="vDataTable"
        :headers="headers"
        :items="users"
        hide-default-footer
        class="elevation-0"
      >
        <template #item="{ item, index, headers }">
          <tr>
            <td>
              {{ index + 1 + (page - 1) * 10 }}
            </td>
            <td>
              <v-list-item-avatar>
                <v-img :src="getImage('/' + item.avatar)" :alt="item.name"></v-img>
              </v-list-item-avatar>
            </td>
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ item.username }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td>
              <v-chip :color="getColor(item.status)" dark>
                {{ item.status }}
              </v-chip>
            </td>
            <td>
              <v-chip :color="getColorMember(item.member_id)" v-if="item.member_id == 1">
                PLATINUM
              </v-chip>
              <v-chip :color="getColorMember(item.member_id)" v-if="item.member_id == 2">
                GOLD
              </v-chip>
              <v-chip :color="getColorMember(item.member_id)" v-if="item.member_id == 3">
                SILVER
              </v-chip>
              <v-chip :color="getColorMember(item.member_id)" v-if="item.member_id == 4">
                FREE
              </v-chip>
            </td>
            <td>
              <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
              <v-icon small @click="deleteItem(item)" v-if="user.roles == 'ADMIN'">
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-center">
        <v-pagination
          v-model="page"
          @input="go"
          :length="lengthPage"
          :total-visible="5"
          color="#1b5e20"
        ></v-pagination>
      </div>
    </base-material-card>
    <div class="text-center">
      <v-dialog v-model="progressBar" width="100" hide-overlay>
        <v-progress-circular
          :size="60"
          color="primary"
          indeterminate
          align-center
          justify-center
        ></v-progress-circular>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    valid: true,
    users: [],
    keyword: "",
    page: 0,
    lengthPage: 0,
    headers: [
      { text: "No", value: "id" },
      { text: "Icon", value: "avatar" },
      { text: "Name", value: "name" },
      { text: "Username", value: "username" },
      { text: "Email", value: "email" },
      { text: "Status", value: "status" },
      { text: "Member", value: "member_id" },
      { text: "Actions", sortable: false },
    ],
    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {
      name: "",
      avatar: "",
      roles: "",
      phone: "",
      email: "",
      password: "",
    },
    defaultItem: {
      name: "",
      avatar: "",
      roles: "",
      phone: "",
      email: "",
      password: "",
    },
    selectedFile: null,
    progressBar: false,
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 20) || "Max 20 characters",
    ],
    usernameRules: [(v) => !!v || "Username is required"],
    imageRules: [(v) => !!v || "Cover avatar is required"],
    phoneRules: [
      (v) => !!v || "Phone Number is required",
      (v) => /([0-9])/.test(v) || "Phone Number must be valid",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /([a-zA-Z0-9_]{1,})(@)([a-zA-Z0-9_]{2,}).([a-zA-Z0-9_]{2,})+/.test(v) ||
        "E-mail must be valid",
    ],
    showPassword: false,
    password: "",
    passwordRules: [
      (v) => !!v || "Password required.",
      (v) => (v && v.length >= 6) || "Min 6 characters",
    ],
    items: ["ADMIN", "STAFF"],
  }),
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    this.go();
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
    }),

    go() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/users?page=" + this.page;
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          let { meta } = response.data;
          this.users = data;
          // jumlah halaman di dapat dari meta endpoint users
          this.lengthPage = meta.last_page;
          this.page = meta.current_page;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    getColor(status) {
      if (status == "ACTIVE") return "green";
      else return "red";
    },
    getColorMember(member) {
      if (member == 1) return "white";
      else if (member == 2) return "yellow";
      else if (member == 3) return "blue";
      else return "gree";
    },
    doSearch() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let keyword = this.keyword;
      if (keyword.length > 0) {
        this.axios
          .get("/users/search/" + keyword, config)
          .then((response) => {
            let { data } = response.data;
            this.users = data;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.go();
      }
    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.progressBar = true;
      let formData = new FormData();
      formData.set("id", this.editedItem.id);
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      this.axios
        .post("/users/delete", formData, config)
        .then((response) => {
          let { data } = response;
          this.setAuth(data.data);
          this.setAlert({
            status: true,
            text: data.message,
            color: "success",
          });
          this.users.splice(this.editedIndex, 1);
          this.closeDelete();
          this.users.push(this.editedItem);
          this.go();
          this.progressBar = false;
        })
        .catch((error) => {
          let { data } = error;
          this.setAlert({
            status: true,
            text: data.message,
            color: "error",
          });
          this.users.push(this.editedItem);
          this.go();
          this.progressBar = false;
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.progressBar = true;
        let formData = new FormData();
        formData.set("name", this.editedItem.name);
        // formData.set('slug', this.editedItem.slug)
        formData.set("avatar", this.selectedFile);
        formData.set("user_id", this.user.id);
        formData.set("id", this.editedItem.id);
        formData.set("username", this.editedItem.username);
        formData.set("roles", this.editedItem.roles);
        formData.set("phone", this.editedItem.phone);
        formData.set("email", this.editedItem.email);
        formData.set("password", this.editedItem.password);
        let config = {
          headers: {
            Authorization: "Bearer " + this.user.api_token,
          },
        };
        if (this.editedIndex > -1) {
          Object.assign(this.users[this.editedIndex], this.editedItem);
          this.axios
            .post("/users/update", formData, config)
            .then((response) => {
              let { data } = response;
              this.setAuth(data.data);
              this.setAlert({
                status: true,
                text: data.message,
                color: "success",
              });
              this.users.push(this.editedItem);
              this.clear();
            })
            .catch((error) => {
              let { data } = error;
              this.setAlert({
                status: true,
                text: data.message,
                color: "error",
              });
              this.clear();
            });
        } else {
          this.axios
            .post("/users/store", formData, config)
            .then((response) => {
              let { data } = response;
              this.setAuth(data.data);
              this.setAlert({
                status: true,
                text: data.message,
                color: "success",
              });
              this.users.push(this.editedItem);
              this.clear();
            })
            .catch((error) => {
              let { data } = error;
              this.setAlert({
                status: true,
                text: data.message,
                color: "error",
              });
              this.clear();
            });
        }
      }
    },
    onFileSelected(event) {
      this.selectedFile = event;
    },
    clear() {
      this.$refs.fileImage.reset();
      this.go();
      this.close();
      this.progressBar = false;
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.position-relative {
  position: relative;
}
</style>
